<template>
  <div class="info-text application-heading">
    What are verified events?
    <template>
      <PulseAndRiskDefinitions
        :initial="'VERIFIED_EVENTS'"
        :new-icon="false"
      ></PulseAndRiskDefinitions>
    </template>
  </div>
</template>

<script>
export default {
  name: "SearchVerifiedInfo",
  components: {
    PulseAndRiskDefinitions: () =>
      import("@/components/grids/PulseAndRiskDefinitions"),
  },
  data: function () {
    return {
      url:
        "https://geosparkio.atlassian.net/wiki/spaces/BGS/pages/2954919937/Verified+Events",
    };
  },
};
</script>

<style scoped>
.info-text {
  font-size: 12px;
  text-align: center;
}
.btn-icon {
  position: relative;
  top: -1px;
}
</style>
